export default __webpack_public_path__ + "static/media/ObviouslyItalic.13664ace.otf";